import { Mode as _Mode } from "./SingleLineEditor";

export { default } from "./SingleLineEditor";

export type Mode = _Mode;
